/*=========================================================================================
  File Name: module-usertax-actions.js
  Description: UserTax Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import AvaReportAPI from '@/api/AvaReportAPI.js';
import commonFunc from '@/common/commonFunction';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import { MSEnum } from '../../common/enumeration';
import i18n from '@/i18n/i18n';

export default {
	getTotalReportAvaInvoiceRisk: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: AvaReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/totalinvoicesrisk',
			data: payload
		});
		return res;
	},

	getTotalReportAvaInvoiceRiskByOrg: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: AvaReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/totalinvoicesriskbyorg',
			data: payload
		});
		return res;
	},

	getTotalAmountReportInvoiceRisk: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: AvaReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/totalamountreportinvoicesrisk',
			data: payload
		});
		return res;
	},

	getTotalAmountReportInvoiceRiskByOrg: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: AvaReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/totalamountreportinvoicesriskbyorg',
			data: payload
		});
		return res;
	},

	/**
	 * Tình trạng hoạt động nhà cung cấp
	 * @author dqduy 10.06.2024
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	getActiveStatusSupplier: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: AvaReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/getactivestatussupplier',
			data: payload
		});
		return res;
	},

	/**
	 * dựa vào tình trạng hoạt động lấy ra ncc
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	getSupByStatus: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: AvaReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/getsupbystatus',
			data: payload
		});
		return res;
	},

	getTotalReportInvoiceByStatusSuppliers: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: AvaReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/totalreportinvoicebystatussuppliers',
			data: payload
		});
		return res;
	},

	getTotalReportInvoiceByOrg: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: AvaReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/totalreportinvoicebyorg',
			data: payload
		});
		return res;
	},

	getTotalReportAmountInvoiceByStatusSuppliers: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: AvaReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/totalamountreportinvoices',
			data: payload
		});
		return res;
	},

	getTotalAmountReportInvoiceByOrg: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: AvaReportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/totalamountreportinvoicesbyorg',
			data: payload
		});
		return res;
	}
};
